import styled from "styled-components";

export const DashboardCalenderWrapper = styled.div`
  > .date {
    font-size: 16px;
    cursor: pointer;
    font-family: Pretendard;
    font-size: 23.16px;
    font-weight: 700;
    text-align: center;
    width: 140px;
  }
`;

export const CalenderWrapper = styled.div<{ isTop: boolean; isWide: boolean }>`
  position: absolute;
  ${(p) => (p.isTop ? "top: 30px;" : "")}
  ${(p) => (p.isTop ? "left: 0;" : "")}
  ${(p) =>
    p.isWide
      ? ""
      : `
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    `}
  background: white;
  padding: ${(p) => (p.isWide ? "40px 36px" : "30px 26px")};
  z-index: 1000;
  color: #000;
  width: ${(p) => (p.isWide ? "426px" : "calc(100% - 32px)")};
  border-radius: ${(p) => (p.isWide ? "38px" : "6.16px")};
  box-shadow: 0px 4px 4px 0px #00000040;
  box-sizing: border-box;

  > .button {
    width: 100%;
    height: 50px;
    border-radius: 15px;
    background: #7f25fb;
    color: #fff;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    line-height: 50px;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
  }
`;

export const CalenderGrid = styled.div<{ isWide: boolean }>`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  gap: ${({ isWide }) => (isWide ? "5px" : "2.5px")};
  font-family: Pretendard;
  font-size: ${({ isWide }) => (isWide ? "16px" : "12px")};

  font-weight: 600;
  text-align: center;

  > .label {
    margin: 10px 0;
  }

  > .empty {
    color: #fff;
    padding: 10px;
  }
`;

export const CalenderDay = styled.div<{ type: string; isWide: boolean }>`
  cursor: pointer;
  color: #a6a6a6;
  width: ${({ isWide }) => (isWide ? "48px" : "36px")};
  height: ${({ isWide }) => (isWide ? "48px" : "36px")};
  line-height: ${({ isWide }) => (isWide ? "48px" : "36px")};
  border-radius: 50%;
  box-sizing: border-box;

  ${(p) =>
    p.type === "select"
      ? `
      background: #7f25fb;
      color: #fff;
      `
      : p.type === "blur"
      ? `
      color: #3f6262;
      background: #e3f5f5;
      `
      : p.type === "today"
      ? `
      border: 1px solid #7f25fb;
      `
      : ""}
`;

export const CalenderHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;

  > .title {
    font-family: Pretendard;
    font-size: 26px;
    font-weight: 600;
    text-align: left;
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > img {
      width: 14px;
      height: 14px;
    }
  }
`;

export const CalenderHeaderDateWrapper = styled.div<{ isWide: boolean }>`
  font-family: Pretendard;
  font-size: ${({ isWide }) => (isWide ? "16px" : "12px")};
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .reset {
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 600;
    color: #bebebe;
    cursor: pointer;
  }
`;

export const CalenderHeaderDate = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;

  > .date {
    width: 95px;
    text-align: center;
  }

  > img {
    cursor: pointer;
    width: 6px;
    height: 11px;
  }
`;
